/**
 * 刷新器
 */
export default {
    maximum: {
        overflow: `搜尋限制 <b class="text-danger">%s</b> 筆<br/>超出部分將自動截斷`
    },
    header: {
        start: "下拉刷新",
        trigger: "鬆開刷新",
        loading: "正在讀取中",
        complete: "讀取完成",
        failure: "刷新失敗",
        success: "刷新完成",
    },
    footer: {
        complete: "讀取完成",
        loading: "正在讀取中",
        failure: "讀取失敗",
        no: {
            more: "已經到底了"
        }
    }
}
